/**
 * Get path to data where to find translatable data.
 * @param dataField Data field to fetch translatable data from, e.g.
 *                  presentationName, or
 *                  enrichmentData.info.{language}.description
 * @param language User's active language
 * @returns {string|*} The path where to find the data
 */
function getTranslatableDataPath(dataField, language) {
  if (dataField.indexOf('{language}') !== -1) {
    // Turns dataField "enrichmentData.info.{language}.description" into
    // "enrichmentData.info.SE-sv.description" (if using language SE-sv).
    return dataField.replace('{language}', `info.${language}`);
  }
  // Turns dataField "presentationName" into "info.SE-sv.presentationName" (if
  // using language SE-sv).
  return `info.${language}.${dataField}`;
}

/**
 * Get path in the raw table data where to find data for a column.
 * @param column Column to get data path for
 * @param language User's active language
 * @returns {string|*} The data path where to find data for the column.
 */
function getColumnDataPath(column, language) {
  if (!Object.prototype.hasOwnProperty.call(column, 'dataField')) {
    throw new Error(
      `No dataField specified for column with name "${column.name}"`
    );
  }
  let dataPath;
  if (column.translatable) {
    dataPath = getTranslatableDataPath(column.dataField, language);
  } else {
    dataPath = column.dataField;
  }
  return dataPath;
}

// eslint-disable-next-line import/prefer-default-export
export { getColumnDataPath };
